'use strict';

angular.module('employeeControllers')

.controller('PasswordResetSelectSystemController', ['$scope', function ($scope) {

    $scope.ctxSelectSystem = {};
}]);